"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdDocumentRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class IdDocumentRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('id-document');
    }
    /**
     * Insert a new KYC doc with the provided image URLS.
     * Returns { docId: number }
     */
    create(url, md5, proofUrl) {
        return this.post('/', {
            url,
            md5,
            proofUrl
        });
    }
    /**
     * Submit an ID doc for review
     */
    submit(type, number, issuingCountry, documentCheckId) {
        return this.post(`/submit`, {
            type, number, issuingCountry, documentCheckId
        });
    }
    // Inserts accompanying information for a doc upload.
    update(docId, idNumber, idType, idCountry) {
        return this.post('/update', {
            docId,
            idNumber,
            idType,
            idCountry
        });
    }
    bvn(number, selfieUrl, dob) {
        return this.post('/bvn', {
            bvn: number,
            selfieUrl,
            dob
        });
    }
    getSupportedDocumentTypes() {
        return this.get('/types', {});
    }
    getSupportedPhotoIdentityDocumentTypes() {
        return this.get('/photo_identity_document/types', {});
    }
    getCurrentPhotoIdentityDocument(idCountry) {
        return this.get('/photo_identity_document', { idCountry });
    }
}
exports.IdDocumentRoutes = IdDocumentRoutes;
//# sourceMappingURL=id_document.js.map